import { io } from "socket.io-client";

let socket;

export function getSocket() {
  if (!socket) {
    socket = io(process.env.REACT_APP_API_URL || "http://localhost:4000");
  }
  return socket;
}

// User side — track a specific order's status + rider location + issue updates.
export function trackOrder(orderId, { onStatus, onLocation, onIssue }) {
  const s = getSocket();
  s.emit("join", `order:${orderId}`);
  if (onStatus) s.on("order:status", onStatus);
  if (onLocation) s.on("rider:location", onLocation);
  if (onIssue) s.on("order:issue", onIssue);
  return () => {
    s.emit("leave", `order:${orderId}`);
    if (onStatus) s.off("order:status", onStatus);
    if (onLocation) s.off("rider:location", onLocation);
    if (onIssue) s.off("order:issue", onIssue);
  };
}

// Rider side — receive new-order-assigned pushes on this rider's own room.
export function listenForAssignments(riderId, onAssigned) {
  const s = getSocket();
  s.emit("join", `rider:${riderId}`);
  s.on("order:assigned", onAssigned);
  return () => {
    s.emit("leave", `rider:${riderId}`);
    s.off("order:assigned", onAssigned);
  };
}

// Rider side — a new job offer to accept/pass, updates to an issue this
// rider raised, and status changes (e.g. Support cancelling the order out
// from under them) on their currently-assigned order. Safe to call alongside
// listenForAssignments (same room).
export function listenForRiderEvents(riderId, { onOffered, onIssueUpdate, onStatusUpdate } = {}) {
  const s = getSocket();
  s.emit("join", `rider:${riderId}`);
  if (onOffered) s.on("order:offered", onOffered);
  if (onIssueUpdate) s.on("order:issue", onIssueUpdate);
  if (onStatusUpdate) s.on("order:status", onStatusUpdate);
  return () => {
    s.emit("leave", `rider:${riderId}`);
    if (onOffered) s.off("order:offered", onOffered);
    if (onIssueUpdate) s.off("order:issue", onIssueUpdate);
    if (onStatusUpdate) s.off("order:status", onStatusUpdate);
  };
}

// Admin side — get notified the moment a dispatcher raises an issue.
export function listenForAdminIssues(onIssueRaised) {
  const s = getSocket();
  s.emit("join", "admins");
  if (onIssueRaised) s.on("order:issue-raised", onIssueRaised);
  return () => {
    s.emit("leave", "admins");
    if (onIssueRaised) s.off("order:issue-raised", onIssueRaised);
  };
}

// Admin side — get notified the moment a user submits a support ticket.
export function listenForAdminSupport(onTicketRaised) {
  const s = getSocket();
  s.emit("join", "admins");
  if (onTicketRaised) s.on("support:ticket-raised", onTicketRaised);
  return () => {
    s.emit("leave", "admins");
    if (onTicketRaised) s.off("support:ticket-raised", onTicketRaised);
  };
}

// Rider side — a live nudge that a new job opened on the job board (nobody
// nearby was found, or everyone passed/timed out) instead of needing a
// manual refresh to see it.
export function listenForJobBoard(onUpdate) {
  const s = getSocket();
  s.emit("join", "jobboard");
  if (onUpdate) s.on("jobboard:updated", onUpdate);
  return () => {
    s.emit("leave", "jobboard");
    if (onUpdate) s.off("jobboard:updated", onUpdate);
  };
}
